const businessLandingES = {
	hero: {
		title: "Tu negocio, creciendo y sin estrés",
		subtitle:
			"Si tienes un negocio o quieres empezar uno, Sin Fila automatiza reservas, recordatorios y la gestión de tu equipo, y te ayuda a atraer más clientes.",
		primaryCta: "Registrar negocio gratis",
		storeText: "Disponible en iOS · Android",
		noteStrong: "Comienza tu prueba gratuita de 14 días ahora",
		noteRest: " • Configura tu negocio en solo 15 min • Sin complicaciones ni contratos • Cancela en cualquier momento",
	},

	problem: {
		title: "El problema real",
		subtitle: "¿Te pasa esto?",
		items: [
			"📱 Respondes WhatsApp todo el día (y de noche)",
			"📆 Horarios cruzados o espacios vacíos",
			"🚶 Clientes llegan, ven fila larga… y se van",
			"📊 No saber cuántos clientes atendiste este mes",
			"🌐 Te cuesta atraer nuevos clientes y aumentar la visibilidad de tu negocio",
		],
		itemspart2: ["⏳ Si no hay nadie → pierdes tiempo.", "😤 Si hay demasiada fila → pierdes clientes."],
		description: "💸 Cada cliente que se va por la fila es dinero perdido.",
		highlight: "👉 Muchos negocios pierden hasta 20% de sus ingresos por gestión de citas, tiempos muertos y clientes que se van al esperar.",
	},

	didYouKnow: {
		title: "Sabías que...",
		items: [
			"Más del 70% de los clientes prefieren reservar online si pueden",
			"Automatizar citas te saca del WhatsApp todo el día",
			"Los recordatorios automáticos reducen las ausencias",
			"Centralizar los datos de ventas te ayuda a tomar mejores decisiones para crecer",
		],
		highlight: "✅ Sin Fila organiza tu agenda para que no pierdas clientes y te da visibilidad online para crecer tu negocio.",
	},

	solution: {
		title: "Sin Fila lo soluciona",
		points: [
			{
				title: "Nunca pierdas una reserva",
				desc: "Todas tus citas, confirmaciones y recordatorios en un solo lugar.",
			},
			{
				title: "Atrae nuevos clientes y llena tu agenda",
				desc: "Muestra tu negocio a más clientes en nuestro marketplace.",
			},
			{
				title: "Ahorra tiempo gestionando tu negocio y tu equipo",
				desc: "Administra tus servicios y los calendarios de tu personal sin esfuerzo.",
			},
			{
				title: "Reservas fáciles para tus clientes",
				desc: "Tus clientes reservan, modifican y reciben recordatorios automáticamente.",
			},
		],
	},

	businessBenefits: {
		title: "Beneficios para negocios",
		subtitle: "Organiza tu agenda, automatiza citas y evita perder clientes.",
		items: [
			"Recibir reservas online 24/7",
			"Confirmaciones automáticas y recordatorios",
			"Horarios claros y sin cruces",
			"Perfil público para conseguir clientes nuevos",
			"Menos tiempo en WhatsApp — más tiempo trabajando",
		],
	},

	customerBenefits: {
		title: "Beneficios para clientes",
		subtitle: "Reserva tu cita en segundos, sin llamadas ni espera.",
		items: [
			"Ver disponibilidad real",
			"Reservar al instante",
			"Recibir recordatorios automáticos",
			"Reprogramar o cancelar sin estrés",
			"Encontrar barberías, salones y más cerca de ti",
		],
	},

	howToStart: {
		title: "Cómo empezar",
		steps: [
			{ title: "Crea tu cuenta gratis", desc: "Regístrate en minutos y configura tu negocio." },
			{ title: "Añade tus servicios y tu equipo", desc: "Personaliza tu perfil y horarios." },
			{ title: "Empieza a recibir reservas", desc: "Y deja que Sin Fila haga el resto." },
		],
	},

	pricing: {
		title: "Un plan simple, todo incluido",
		planTitle: "Paga solo por lo que usas:",
		planItems: ["💳 $15 USD / mes — primer usuario", "👥 $12 USD / mes — por cada usuario adicional"],
		note: "Sin contratos. Sin cargos escondidos. Cancela cuando quieras.",
		autoTitle: "Pagar Sin Fila es simple y automático:",
		autoItems: [
			"Aceptamos tarjetas de crédito y débito directamente en la plataforma",
			"El cobro se realiza mensualmente de forma automática",
			"Puedes cancelar en cualquier momento, sin contratos ni permanencias",
		],
		priceNote: "Prueba gratuita de 14 días",
	},

	referral: {
		title: "Programa de Referidos",
		banner: "¡Refiere un negocio y ambos reciben 1 mes gratis!",
		subtitle: "Invita a otros negocios y ahorra mientras creces con Sin Fila.",
		steps: [
			"Paso 1: envía tu código de referido",
			"Paso 2: el invitado completa su registro",
			"Paso 3: ambos obtienen un mes gratis para un usuario",
			"* Detalles disponibles en la app",
		],
	},

	final: {
		text: "Empieza gratis ahora y aprovecha nuestro programa de referidos",
		button: "Registrar negocio gratis",
	},

	contact: {
		question: "¿Tienes preguntas? Estamos para ayudarte.",
		website: "reservasinfila.com",
		email: "hola@reservasinfila.com",
		phone: "+1 (514) 758-6041",
	},

	misc: {
  badge: "Sin Fila para negocios",
  freeMonthsTag: "🎁 Meses gratis",
  labelChallenge: "El Problema",
  labelResearch: "¿Sabías que...?",
  labelHowItWorks: "Cómo Funciona",
  labelPricing: "Precios",
  priceNote: "/ mes por usuario",  // move from pricing.priceNote
},
};

export default businessLandingES;
